document.addEventListener('DOMContentLoaded', function() {

  // Basis swiper + mogelijk lightgallery

  document.querySelectorAll('.block-page-carousel').forEach(carousel => {
    const swiperWrapper = carousel.querySelector('.swiper-wrapper');
    const swiperId = carousel.id;

    const swiper = new Swiper(carousel.querySelector('.swiper-container'), {
      grabCursor: true,
      slidesPerView: 1.5,
      spaceBetween: 16,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        576: {
          spaceBetween: 20,
          slidesPerView: 1.15,
        },
        1024: {
          slidesPerView: 1.75,
          spaceBetween: 30,
        },
        1400: {
          spaceBetween: 40,
        },
        1500: {
          spaceBetween: 50,
          slidesPerView: 1.75,
        },
      },
      on: {
        // init: function (swiper) {
        //   setTimeout(() => {
        //     swiper.slideToLoop(swiper.realIndex, 0, false); // Forceert juiste positie
        //   }, 50);
        // },
      }
    });

  });

});